import React, {Component} from 'react'
import {connect} from 'react-redux'
import WithAjax from '../common/helpers/WithAjax'
import {fetchSkillVendorHistoryProfileStatusesSuccess} from '../../actions/pages/skillvendor-page'
import Table from '../../tables/reactable/DefaultTable'
import StatusBadge from '../common/helpers/StatusBadge'

class HistoryProfileStatusesGrid extends Component {
  constructor() {
    super()
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.onFilter = this.onFilter.bind(this)
    this.state = {
      itemsPerPage: 10,
      filter: {
        ProfileTypeLabel: ''
      }
    }
    this.columns = [
      'ProfileTypeLabel',
      'Status',
      'StatusModifiedDate',
      'StatusModifiedBy'
    ]
    this.columnNames = [
      'Profile',
      'Status',
      'Date',
      'Modified By'
    ]
  }

  componentDidMount() {
    if (this.props.statuses === null){
      this.fetchStatuses();
    }
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  fetchStatuses() {
    let url = 'skillVendors/' + this.props.skillVendorId + '/profilesHistory'

    this.props.ajax.get(url, true, (data) => {
      this.props.fetchSkillVendorHistoryProfileStatusesSuccess(data);
    });
  }

  onFilter(filter){
    this.setState({
      filter: filter
    })
  }

  render() {
    if (this.props.statuses === null) {
      return (<div />)
    }

    let items = this.props.statuses.map(item => {
      return Object.assign({}, item, {
        Status: (<StatusBadge status={item.Status.toLowerCase()} statusLabel={item.StatusLabel} />),
        StatusModifiedDate: (<span statusmodifieddate={item.StatusModifiedDate}>{item.StatusModifiedDateAsString}</span>),
      })
    });

    return (
      <div>
        <Table
          items={items}
          columns={this.columns}
          columnNames={this.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          filterable={[{
            column: 'ProfileTypeLabel',
            filters: 'auto'
          }]}
          filter={this.state.filter}
          onFilter={this.onFilter}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={false}
          sortable={[
            'ProfileTypeLabel',
            {
                column: 'Status',
                sortFunction: function(a, b){
                  return a.props.statusLabel.localeCompare(b.props.statusLabel);
                }
            },
            {
                column: 'StatusModifiedDate',
                sortFunction: function(a, b) {
                  return a.props.statusmodifieddate.localeCompare(b.props.statusmodifieddate);
                }
            },
            'StatusModifiedBy'
          ]}
          defaultSort={{column: 'StatusModifiedDate', direction: 'desc'}}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  skillVendorId: state.skillVendorPage.overview.Id,
  statuses: state.skillVendorPage.profileStatuses
})
const mapDispatchToProps = dispatch => ({
  fetchSkillVendorHistoryProfileStatusesSuccess(statuses) { dispatch(fetchSkillVendorHistoryProfileStatusesSuccess(statuses)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(HistoryProfileStatusesGrid))
